module.exports = __webpack_public_path__ + "img/demo-leadIn.5cda60d6.png";